import { Pipe, PipeTransform } from '@angular/core';
import { Files } from '../../common/util/files';

@Pipe({ name: 'fileName' })
export class FilePipe implements PipeTransform {
  transform(obj: any, args?: any): any {
    return obj ? Files.getFileName(obj) : '';
  }
}
